import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

export const KnowISDE = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const navigate = useNavigate();

  return (
    <section ref={ref} className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
              About Us
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Know <span className="text-blue-600">ISDE Academy</span>
            </h2>

            <p className="text-lg text-gray-600 leading-relaxed">
              ISDE is a leading authority in international standards training, dedicated to empowering businesses across diverse sectors. With a proven track record of expertise spanning over a decade, we offer a wide range of courses designed to enhance your knowledge and skills.
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              Our commitment to excellence is reflected in our vibrant training communities and premium professional development programs, ensuring that you're equipped to meet the ever-evolving challenges of your industry. Join us at ISDE and embark on a transformative educational journey today.
            </p>

            <div className="pt-4">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg transition-all hover:scale-105 hover:shadow-xl"
                onClick={() => navigate('/about')}
              >
                Read More About Us
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
